export const BIGDES_IMPLEMENTATION_PROCESS_AUDIT_METHODS = [
    'interview',
    'review',
    'security_audit',
    'penetration_test',
    'source_code_analysis',
    'other',
];

export const BIGDES_IMPLEMENTATION_PROCESS_EFFECTIVENESS_STATUSES = [
    'effective',
    'not_effective',
    'partially_effective',
];

export const BIGDES_IMPLEMENTATION_PROCESS_QUESTIONS = [
    {
        questionNo: 1,
        question: {
            tr: 'Kurum varlık grupları, Rehberde yer alan varlık grubu ana başlıkları ile uyumlu olacak şekilde tanımlanmış mıdır?',
            en: 'Are the Institution\'s asset groups defined in alignment with the main asset group headings in the Guide?',
        },
    },
    {
        questionNo: 2,
        question: {
            tr: 'Kurum bilgi varlıkları en az bir varlık grubu altında tanımlanmış mıdır?',
            en: 'Are the Institution\'s information assets defined under at least one asset group?',
        },
    },
    {
        questionNo: 3,
        question: {
            tr: 'Varlık grupları tanımlama çalışmaları, varsa bilgi güvenliği yönetim sistemi kapsamında oluşturulan varlık envanteri ile ilişkilendirilmiş midir?',
            en: 'Are the asset-group definition activities linked to the asset inventory created within the information security management system, where one exists?',
        },
    },
    {
        questionNo: 4,
        question: {
            tr: 'Varlık grupları kritiklik dereceleri Rehbere uygun olarak belirlenmiş midir?',
            en: 'Are asset-group criticality levels determined in accordance with the Guide?',
        },
    },
    {
        questionNo: 5,
        question: {
            tr: 'Varlık gruplarına uygulanacak tedbirler kritiklik derecesine uygun olarak belirlenmiş midir?',
            en: 'Are the measures to be applied to asset groups determined according to their criticality levels?',
        },
    },
    {
        questionNo: 6,
        question: {
            tr: 'Uygulama ve teknoloji alanına yönelik tedbirler ve sıkılaştırma tedbirleri varlık grubu ile uygun bir şekilde eşleştirilmiş midir?',
            en: 'Are application, technology, and hardening measures appropriately matched with the asset group?',
        },
    },
    {
        questionNo: 7,
        question: {
            tr: 'Her bir varlık grubu için mevcut durum ve boşluk analizi çalışmaları yapılmış mıdır?',
            en: 'Have current-state and gap analyses been performed for each asset group?',
        },
    },
    {
        questionNo: 8,
        question: {
            tr: 'Telafi edici kontroller dokümante edilmiş midir?',
            en: 'Are compensating controls documented?',
        },
    },
    {
        questionNo: 9,
        question: {
            tr: 'Rehber uygulama yol haritası oluşturulmuş mudur?',
            en: 'Has an implementation roadmap for the Guide been created?',
        },
    },
];

export function getImplementationProcessQuestionByNo(questionNo) {
    return BIGDES_IMPLEMENTATION_PROCESS_QUESTIONS.find((q) => q.questionNo === questionNo) || null;
}
